"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const applepay = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-applepay` : '') + (description ? ` desc-applepay` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-applepay"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-applepay"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.6 0H2.68c-.23.01-.47.03-.71.07A2.45 2.45 0 0 0 .71.7a2.23 2.23 0 0 0-.64 1.22A4.52 4.52 0 0 0 0 2.94v18.19c.01.23.03.47.07.7a2.3 2.3 0 0 0 .64 1.22 2.27 2.27 0 0 0 1.26.63 4.92 4.92 0 0 0 1.04.07h32.31c.23-.01.47-.03.71-.07a2.45 2.45 0 0 0 1.26-.63 2.23 2.23 0 0 0 .64-1.22A4.51 4.51 0 0 0 38 20.8V2.62a5.53 5.53 0 0 0-.07-.7A2.3 2.3 0 0 0 37.3.7a2.28 2.28 0 0 0-1.26-.63A4.9 4.9 0 0 0 34.99 0h-.4Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.6.8h.38a15.86 15.86 0 0 1 .9.05 1.47 1.47 0 0 1 1.25 1.22 3.85 3.85 0 0 1 .06.88V20.8a13.3 13.3 0 0 1-.06.89 1.51 1.51 0 0 1-.42.8 1.46 1.46 0 0 1-.82.41 4.22 4.22 0 0 1-.91.06H2.71c-.17-.01-.4-.02-.6-.06a1.62 1.62 0 0 1-.45-.14 1.45 1.45 0 0 1-.8-1.07 3.83 3.83 0 0 1-.05-.89V2.94a14.58 14.58 0 0 1 .06-.88 1.53 1.53 0 0 1 .42-.8A1.47 1.47 0 0 1 2.1.85 4.14 4.14 0 0 1 3 .79h31.6Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.37 7.99c.33-.4.55-.93.5-1.48-.48.03-1.07.3-1.4.7-.3.35-.57.9-.5 1.43a1.8 1.8 0 0 0 1.4-.65Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.86 8.74c-.78-.05-1.44.43-1.81.43-.37 0-.94-.41-1.55-.4a2.3 2.3 0 0 0-1.95 1.16c-.84 1.4-.22 3.48.59 4.62.4.57.87 1.2 1.5 1.17.59-.02.82-.37 1.54-.37.71 0 .92.37 1.55.36.65-.01 1.05-.57 1.45-1.13.45-.65.63-1.27.65-1.3-.02-.02-1.26-.48-1.27-1.87 0-1.17.98-1.72 1.02-1.76a2.21 2.21 0 0 0-1.72-.91Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.62 7.16c1.68 0 2.86 1.14 2.86 2.79 0 1.66-1.2 2.8-2.9 2.8H15.7v2.9h-1.35V7.16h3.26Zm-1.91 4.48h1.54c1.18 0 1.85-.61 1.85-1.69 0-1.07-.67-1.68-1.84-1.68h-1.55v3.37Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.83 13.9c0-1.1.85-1.76 2.36-1.84l1.73-.1v-.48c0-.68-.47-1.1-1.27-1.1-.75 0-1.22.36-1.34.91H21.1c.07-1.12 1.04-1.94 2.61-1.94 1.54 0 2.52.8 2.52 2.03v4.27h-1.25v-1.02h-.03a2.28 2.28 0 0 1-2 1.13c-1.24 0-2.1-.76-2.1-1.87Zm4.1-.57v-.49l-1.57.1c-.77.05-1.21.39-1.21.92 0 .54.45.89 1.15.89.91 0 1.62-.61 1.62-1.42Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.4 17.93V16.9c.1.02.31.02.42.02.6 0 .93-.25 1.13-.88l.11-.38-2.29-6.2h1.41l1.6 5.04h.03l1.6-5.04h1.38l-2.38 6.51c-.54 1.5-1.17 1.99-2.48 1.99-.11 0-.44-.01-.53-.03Z",
    fill: "black"
  }));
};
var _default = exports.default = applepay;